<ul class="breadcrumb" style="display: flex;">
  @for (url of _urls; track url; let last = $last) {
    <li
      [ngClass]="{ 'breadcrumb-item': useBootstrap, active: last }"
      ngClass.lt-md="breadcrumb-item-minimized"
      >
      <!-- disable link of last item -->
      @if (!last) {
        <a
          class="breadcrumbLink"
          role="link"
          (click)="navigateTo(url)"
          routerLink
          >
          {{ friendlyName(url) }}&nbsp;
        </a>
      }
      @if (last) {
        <span class="breadcrumbLast">
          {{ friendlyName(url) }}
        </span>
      }
    </li>
  }
</ul>
